import React, { useState } from 'react';
import axios from 'axios';
import { Gift, XCircle } from 'lucide-react';
import { Input } from './ui/input';
import { Button } from './ui/button';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const GiftCardInput = ({ giftCard, onChange }) => {
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const apply = async () => {
    if (!code.trim()) return;
    setLoading(true);
    setError('');
    try {
      const { data } = await axios.get(`${API}/gift-cards/validate/${encodeURIComponent(code.trim().toUpperCase())}`);
      onChange({ code: data.code, balance: data.balance });
    } catch (err) {
      setError(err.response?.data?.detail || 'Tarjeta regalo no válida');
    } finally {
      setLoading(false);
    }
  };

  if (giftCard) {
    return (
      <div className="flex items-center justify-between bg-green-50 border border-green-200 p-3 mb-4" data-testid="gift-card-applied">
        <span className="text-sm text-green-800 flex items-center gap-2"><Gift className="w-4 h-4" /> {giftCard.code} · saldo {giftCard.balance.toFixed(2)}€</span>
        <button onClick={() => onChange(null)} className="text-red-500" data-testid="gift-card-remove"><XCircle className="w-4 h-4" /></button>
      </div>
    );
  }

  return (
    <div className="mb-4" data-testid="gift-card-section">
      <p className="text-sm font-semibold mb-2 flex items-center gap-2"><Gift className="w-4 h-4" /> ¿Tienes una tarjeta regalo?</p>
      <div className="flex gap-2">
        <Input value={code} onChange={(e) => setCode(e.target.value.toUpperCase())} placeholder="Código de la tarjeta" className="uppercase rounded-none" data-testid="gift-card-input" />
        <Button onClick={apply} disabled={loading} className="bg-black text-white rounded-none" data-testid="gift-card-apply">{loading ? '...' : 'Aplicar'}</Button>
      </div>
      {error && <p className="text-xs text-red-600 mt-1" data-testid="gift-card-error">{error}</p>}
    </div>
  );
};
